import { Dropdown } from 'react-bootstrap';
import { Typography } from 'app/components/ui';

export interface FooterAction {
  key: string;
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

export const FooterActionsMenu = ({ actions }: { actions: FooterAction[] }) => {
  return (
    <Dropdown drop="up" align="end">
      <Dropdown.Toggle as="button" className="btn btn-secondary tags-footer__button" bsPrefix="footer-actions-toggle">
        <i className="fa-solid fa-ellipsis-vertical" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="new-dropdown__list">
        {actions.map((action) => (
          <Dropdown.Item key={action.key} className="new-dropdown__list--item" disabled={action.disabled} onClick={action.onClick}>
            <Typography variant="body-5" fontWeight="light" color={action.disabled ? '#9a99a0' : '#1E2533'}>
              {action.label}
            </Typography>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
